exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-593b0e68]{width:1200px;min-height:200px;margin-left:auto;margin-right:auto;z-index:10;margin-top:-100px;background:#fff;border-radius:0 0 20px 20px}@media (max-width:1280px){section[data-v-593b0e68]{width:calc(100% - 80px)}}@media (max-width:768px){section[data-v-593b0e68]{padding-top:200px;width:95%;margin-left:auto;margin-right:auto;text-align:center}}@media (max-width:500px){section[data-v-593b0e68]{padding-top:360px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-593b0e68","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true,"data":"@import /"/Users/pola/Documents/udemy/prototype_boxed_layout/src/assets/scss/variables.scss/";"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Subhero.vue
// module id = 113
// module chunks = 0